import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'sn-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilePreviewComponent {
  @Input()
  get file(): File {
    return this._file;
  }
  set file(value: File) {
    this._file = value;
    if (value.type.indexOf('image') !== -1) {
      this._handleImageBlob();
    } else {
      this.icon = this._setBlobIcon();
    }
  }
  @Input()
  public showRemoveButton = true;

  @Input()
  public showTitle = true;

  @Output()
  public readonly removeFile = new EventEmitter<void>();

  public imageUrl: SafeUrl;
  public icon: string;

  private _file: File;

  constructor(private readonly _sanitizer: DomSanitizer) {}

  public clear(): void {
    this.removeFile.emit();
  }

  private _handleImageBlob(): void {
    const objectURL = URL.createObjectURL(this._file);
    this.imageUrl = this._sanitizer.bypassSecurityTrustUrl(objectURL);
  }

  private _setBlobIcon(): string {
    if (this._file.type.indexOf('video') !== -1) {
      return 'fa-file-video';
    }

    if (this._file.type.indexOf('audio') !== -1) {
      return 'fa-file-audio';
    }

    return 'fa-file';
  }
}
